import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ChartCard from "../components/shared/ChartCard";
import InfoCard from "../components/shared/InfoCard";
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';

// import background from "../assets/images/background.png";
import PageTitle from "../components/shared/PageTitle";
import RoundIcon from "../components/shared/RoundIcon";
import { IoNewspaperOutline } from "react-icons/io5";
import { FaRegChartBar } from "react-icons/fa";
import { FiPieChart } from "react-icons/fi";
import { RiBook2Line } from "react-icons/ri";
import { IoMdCloseCircleOutline } from 'react-icons/io';

import Kecamatan from "../components/Dashboard/Kecamatan";
import Status from "../components/Dashboard/Status";
import TotalDipinjam from "../components/Dashboard/TotalDipinjam";
import TotalTunggakan from "../components/Dashboard/TotalTunggakan";
import TotalDikembalikan from "../components/Dashboard/TotalDikembalikan";
import Linimasa from "../components/Dashboard/Linimasa";
import { Button } from '@mui/material';

const Dashboard = () => {

  const [peminjaman, setPeminjaman] = useState(0);
  const [kembali, setKembali] = useState(0);
  const [dipinjam, setDipinjam] = useState(0);
  const beUrl = process.env.REACT_APP_BE

  useEffect(() => {
    if(localStorage.getItem('role') !== 'admin' ){
      window.location.href = '/dashboard'
  }

  fetchDataCard();
}, []);

    const fetchDataCard = async () => {
      try {
        const responsePinjam = await axios.get(`${beUrl}/api/v1/pgsql/jumlahPinjam`);
        const responseDipinjam = await axios.get(`${beUrl}/api/v1/pgsql/totalPinjam`);
        const responseKembali = await axios.get(`${beUrl}/api/v1/pgsql/totalKembali`);
        
        setPeminjaman(responsePinjam.data.data);
        setDipinjam(responseDipinjam.data.data);
        setKembali(responseKembali.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };



  const TotalBT = 272672;

  const handleClick = () => {
    // Create a container div for rendering React component inside SweetAlert
    const div = document.createElement('div');
    
    Swal.fire({
      title: 'Total Peminjaman',
      html: div, // Set HTML content with the container div
      showConfirmButton: false, // Sembunyikan tombol konfirmasi
      didOpen: () => {
        // Render the TotalDipinjam component inside the SweetAlert2 container
        ReactDOM.render(<TotalDipinjam />, div);
        
        // Tambahkan ikon penutup
        const closeButton = document.createElement('div');
        closeButton.innerHTML = '<div style="cursor: pointer; position: absolute; right: 20px; top: 20px;"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 10.586l5.293-5.293 1.414 1.414L13.414 12l5.293 5.293-1.414 1.414L12 13.414l-5.293 5.293-1.414-1.414L10.586 12 5.293 6.707l1.414-1.414z" fill="#3085d6"/></svg></div>';
        closeButton.onclick = () => Swal.close(); // Fungsi untuk menutup SweetAlert
        Swal.getHtmlContainer().appendChild(closeButton);
      },
    });
  };


  const handleClickTunggakan = () => {
    // Create a container div for rendering React component inside SweetAlert
    const div = document.createElement('div');
    
    Swal.fire({
      title: 'Total Tunggakan',
      html: div, // Set HTML content with the container div
      showConfirmButton: false, // Sembunyikan tombol konfirmasi
      didOpen: () => {
        // Render the TotalDipinjam component inside the SweetAlert2 container
        ReactDOM.render(<TotalTunggakan />, div);
        
        // Tambahkan ikon penutup
        const closeButton = document.createElement('div');
        closeButton.innerHTML = '<div style="cursor: pointer; position: absolute; right: 20px; top: 20px;"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 10.586l5.293-5.293 1.414 1.414L13.414 12l5.293 5.293-1.414 1.414L12 13.414l-5.293 5.293-1.414-1.414L10.586 12 5.293 6.707l1.414-1.414z" fill="#3085d6"/></svg></div>';
        closeButton.onclick = () => Swal.close(); // Fungsi untuk menutup SweetAlert
        Swal.getHtmlContainer().appendChild(closeButton);
      },
    });
  };


  const handleClickKembali = () => {
    // Create a container div for rendering React component inside SweetAlert
    const div = document.createElement('div');
    
    Swal.fire({
      title: 'Total Dikembalikan',
      html: div, // Set HTML content with the container div
      showConfirmButton: false, // Sembunyikan tombol konfirmasi
      didOpen: () => {
        // Render the TotalDipinjam component inside the SweetAlert2 container
        ReactDOM.render(<TotalDikembalikan />, div);
        
        // Tambahkan ikon penutup
        const closeButton = document.createElement('div');
        closeButton.innerHTML = '<div style="cursor: pointer; position: absolute; right: 20px; top: 20px;"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 10.586l5.293-5.293 1.414 1.414L13.414 12l5.293 5.293-1.414 1.414L12 13.414l-5.293 5.293-1.414-1.414L10.586 12 5.293 6.707l1.414-1.414z" fill="#3085d6"/></svg></div>';
        closeButton.onclick = () => Swal.close(); // Fungsi untuk menutup SweetAlert
        Swal.getHtmlContainer().appendChild(closeButton);
      },
    });
  };
 

  


  return (
    <div className="p-6">
      <PageTitle>Dashboard</PageTitle>
      <div className="grid gap-6 mb-2 grid-cols-1 xl:grid-cols-4">
        {/* <Button onClick={handleClick} ></Button> */}
        <InfoCard
          title="Total Buku Tanah"
          satuan=''
          value={TotalBT.toLocaleString('id-ID')}
        >  
          <RoundIcon
            icon={IoNewspaperOutline} 
            iconColorClass="text-[#6993FF]"
            bgColorClass="bg-[#BDCFFF]"
            className="mr-4"        
          />
         
        </InfoCard>
        <InfoCard
          title="Total Peminjaman"
          satuan='Peminjaman'
          value={peminjaman.length > 0 ? peminjaman[0].jumlahpinjam: ''}
        >
          <RoundIcon
            icon={FaRegChartBar}
            iconColorClass="text-[#6993FF]"
            bgColorClass="bg-[#BDCFFF]"
            className="mr-4"
            onClick={handleClick}
          />
        </InfoCard>
        <InfoCard
          title="Total Tunggakan"
          satuan='Peminjaman'
          value={dipinjam.length > 0 ? dipinjam[0].totaldipinjam: ''}
        >
          <RoundIcon
            icon={RiBook2Line}
            iconColorClass="text-[#6993FF]"
            bgColorClass="bg-[#BDCFFF]"
            className="mr-4"
            onClick={handleClickTunggakan}
          />
        </InfoCard>
        <InfoCard
          title="Total Dikembalikan"
          satuan='Peminjaman'
          value={kembali.length > 0 ? kembali[0].totalkembali: ''}
        >
          <RoundIcon
            icon={FiPieChart}
            iconColorClass="text-[#6993FF]"
            bgColorClass="bg-[#BDCFFF]"
            className="mr-4"
            onClick={handleClickKembali}
          />
        </InfoCard>
      </div>
      <div className="grid gap-6 mb-6 md:grid-cols-2">
        <ChartCard>
        <h6 className="text-left text-sm xl:text-lg font-medium">
            Jumlah BT di Tingkat Kecamatan
          </h6>
        <Kecamatan/>
        </ChartCard>
        <ChartCard>
        <h6 className="text-left text-sm xl:text-lg font-medium">
            Perbandingan BT Berdasarkan Status Bidang
          </h6>
      <Status/>
        </ChartCard>
      </div>

      <div className="grid gap-6 mb-6 md:grid-cols-1">
        <ChartCard>
        <h6 className="text-left text-sm xl:text-lg font-medium">
            Linimasa Peminjaman Dalam 7 Hari
          </h6>
        <Linimasa/>
        </ChartCard>
      </div>

    
    </div>
  );
};

export default Dashboard;
